import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../hooks/useQuriesSuccess';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import useDeleteMutation from '../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../util';
import { RIN_DAI_Schema } from './RIN_DAI_Schema';

/**
 * 조회: 재해현황 아차사고(ACS_BASIC_02)와 동일 API — GetAccBasic02R1
 */
export const useSearch1 = (options = {}) => {
  const { onSuccess, getSearchContext, searchKey } = options;

  const query = useQuery({
    queryKey: ['AccidentStatus', 'getAccBasic02R1', 'RIN_DAI', searchKey],
    queryFn: () => {
      const context = getSearchContext?.() ?? {};
      const params = mapParamsBySchema(RIN_DAI_Schema.mapper.search1, context);
      return apiRequest(
        'post',
        Global.urls.AccidentStatus.getAccBasic02R1,
        params
      );
    },
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/**
 * 저장: SaveAccBasic02U1 (ACS_BASIC_02와 동일)
 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, RIN_DAI_Schema.mapper.save1);
    return apiRequest(
      'post1',
      Global.urls.AccidentStatus.saveAccBasic02U1,
      payload
    );
  }, options);
};

/**
 * 삭제: DeleteAccBasic02D1 (ACS_BASIC_02와 동일)
 */
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, RIN_DAI_Schema.mapper.delete1);
    return apiRequest(
      'post1',
      Global.urls.AccidentStatus.deleteAccBasic02D1,
      payload
    );
  }, options);
};
